module.exports = __webpack_public_path__ + "static/media/hornandbuffett.2e928108.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hornandbuffett.jpeg
// module id = 581
// module chunks = 0